import { BackLink, type BackLinkProps } from './BackLink';

/** Fiche pas affichable : lien retour puis « Chargement… », l'erreur de l'API, ou notFound */
export function DetailPageStatus({
  back,
  loaded,
  error,
  notFound,
}: {
  back: BackLinkProps;
  loaded: boolean;
  error: string | null;
  /** Message quand la fiche n'existe pas (« Utilisateur introuvable. ») */
  notFound: string;
}) {
  return (
    <>
      <BackLink {...back} />
      {loaded ? (
        <p role="alert" className="text-sm text-destructive">
          {error ?? notFound}
        </p>
      ) : (
        <p className="text-sm text-slate-500">Chargement…</p>
      )}
    </>
  );
}
